import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Observable, of, shareReplay, switchMap, takeUntil} from 'rxjs';
import {catchError, delay, finalize, repeat} from "rxjs/operators";
import {Expiration} from "../../interfaces/Expiration";
import {YouTube} from "../../services/PlayerService/YouTube";
import {DS_API_URL} from "../../constants";


@Component({
  selector: 'app-you-tube',
  template: '<div #component></div>',
  styleUrls: []
})
export class YouTubeComponent extends PlayerBase {
  videoSprite;
  listType;
  quality;
  volume;
  randomOrder;
  videoList;
  youtube: YouTube;
  videoId;


  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW);
        }
        this.loadStat();
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      return of(null);
    }
    this.listType = this.data.YouTube[0].$.listType;
    this.quality = this.data.YouTube[0].$.quality;
    this.randomOrder = (this.data.YouTube[0].$.randomOrder == '1');

    const play$ = super.play().pipe(
      switchMap( a => this.playerService.initYoutube()),
      switchMap( r => {
        this.youtube = this.playerService.createYouTube(this.component.nativeElement);
        this.youtube.volume = 100 * Number(this.data.YouTube[0].$.volume);
        return this.youtube.init();
      }),
      shareReplay()
    )
    return play$.pipe(
      switchMap( r => {
        if (this.videoList==null || this.videoList.length==0) {
          return this.requestVideos();
        } else {
          return of('continue');
        }
      }),
      switchMap( r => {
        this.statStart = new Date().getTime();
        return this.playNext();
      } ),
      switchMap( res => {
        if (res!=null && this.statEnabled) {
          const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
          this.playerService.stats.addContent(this.statTag, 2, this.videoId, duration);
        }
        return of('a');
      }),
      repeat(),
    )
  }



  requestVideos(): Observable<any> {
    if (this.listType=="manually")
    {
      let videoId: string;
      this.videoList = [];
      let i0 = 0;
      let i1;
      let inStr: boolean = true;
      const videoIdList = this.data.YouTube[0].VideoIdList[0]
      for(i1=0; i1 < videoIdList.length; i1++)
      {
        let ch: string = videoIdList.charAt(i1);
        if (ch==" " || ch=="," || ch==";" || ch=="\t" || ch=="\n")
        {
          if (inStr)
          {
            videoId = videoIdList.substring(i0, i1);
            this.videoList.push(videoId);
            inStr = false;
          }
          i0 = i1+1;
        }
        else
        {
          inStr = true;
        }
      }
      if (inStr && i1>i0)
      {
        videoId = videoIdList.substring(i0, i1);
        this.videoList.push(videoId);
      }

      if (this.randomOrder) {
        this.shuffleItems();
      }

      return of('ready');
    }
    else
    {
      let url: string = null;

      if (this.listType=="most_viewed")
      {
        url = DS_API_URL + "YouTube/popular/all/" + this.data.YouTube[0].$.listRegion;
      }
      else if (this.listType=="category")
      {
        url = DS_API_URL + "YouTube/cat/" + this.data.YouTube[0].$.category + "/" + this.data.YouTube[0].$.listRegion;
      }
      else if (this.listType=="channel")
      {
        url = DS_API_URL + "YouTube/channel/" + this.data.YouTube[0].$.channel + "/" + this.data.YouTube[0].$.listRegion;
      }

      if (url!=null)
      {
        return this.playerService.caching.requestText(url, 'youtube', Expiration.Hour/*, this.listType + '.txt'*/).pipe(
          switchMap(str => {
            const data = JSON.parse(str);
            this.videoList = [];
            data.forEach((item) => {
              if ((this.listType == "most_viewed" || this.listType == "category") && item.id != null) {
                this.videoList.push(item.id);
              } else if (this.listType == "channel" && item.id != null) {
                this.videoList.push(item.id.videoId);
              }
            });


            if (this.randomOrder) {
              this.shuffleItems();
            }
            return of('done');
          })
        )
      } else {
        return of(null);
      }
    }

  }

  shuffleItems() {
    let randomList = [];
    let videoId: string;
    while(this.videoList.length>0)
    {
      let index = Math.floor(Math.random() * this.videoList.length);
      videoId = this.videoList[index];
      randomList.push( videoId );
      this.videoList.splice(index, 1);
    }
    this.videoList = randomList;
  }

  playNext(): Observable<any> {
    this.videoId = this.videoList.shift();
    if (this.listType == "manually") {
      this.videoList.push(this.videoId);
    }
    if (this.videoId != null) {
      return this.youtube.loadVideoById(this.videoId)
    } else {
      return of(null);
    }
  }


  destroy(): void {
    if (this.youtube!=null) {
      this.youtube.dispose();
    }
    this.youtube = null;

    if (this.videoList!=null) {
      while (this.videoList.length > 0) {
        this.videoList.shift();
      }
      this.videoList = null;
    }

    super.destroy();
  }
}

